import { Scene, Director, SceneAsset } from 'cc';
import { ActivityEventName } from '../../Config/ActivityConfigType';
import globalInstance from '../../System/GlobalInstance';

const originalRunSceneImmediate = Director.prototype.runSceneImmediate;
Director.prototype.runSceneImmediate = function runSceneImmediate(
    scene: Scene | SceneAsset,
    onBeforeLoadScene?: Director.OnBeforeLoadScene,
    onLaunched?: Director.OnSceneLaunched,
) {
    const startTime = Date.now();

    originalRunSceneImmediate.call(this, scene, onBeforeLoadScene, (error: null | Error, targetScene?: Scene) => {
        onLaunched?.(error, targetScene);
        const time = Date.now() - startTime;
        if (globalInstance.game?.activity) {
            globalInstance.game.activity.send(ActivityEventName.RunScene, { scene: targetScene?.name, time });
        }
    });
};
